import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const CheckoutSuccess = () => {
  return (
    <div className="text-center p-5">
      <div className="mb-4">
        <span style={{ fontSize: '4rem' }}>✓</span>
      </div>
      <h2>Payment Successful!</h2>
      <p className="text-muted mb-4">
        Thank you for your order. This was a demo checkout — no real payment was processed.
      </p>
      <Link to="/show-all-products" className="btn btn-primary">
        Continue Shopping
      </Link>
    </div>
  );
};

export default CheckoutSuccess;
